import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class DocumentoImpuestosRetencionForm extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true,
      });
    }
  }

  rules(data) {
    const { TipoFactorDR, ObjetoImpDR } = data || {};

    let isExento = TipoFactorDR === 'Exento' && ObjetoImpDR !== '01';

    return {
      BaseDR: [
        'required',
        'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/'
      ],
      ImpuestoDR: ['required'],
      TipoFactorDR: ['required'],
      TasaOCuotaDR: [
        isExento ? 'string' : 'required',
        'regex:/^[0-0]{1,1}(.[0-9]{6,6})?$/',
      ],
      ImporteDR: [
        isExento ? 'string' : 'required',
        'regex:/^[0-9]{1,18}(.[0-9]{1,6})?$/',
      ],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value,
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      pedimentos: false,
      data: {}
    })
  }

  render() {
    const { isValid, data = {} } = this.state;

    const rules = this.rules(data);

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Base"
              name="BaseDR"
              placeholder=""
              help=""
              rules={ rules.BaseDR }
              value={ data.BaseDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Impuesto"
              name="ImpuestoDR"
              placeholder=""
              help=""
              rules={ rules.ImpuestoDR }
              value={ data.ImpuestoDR }
              options={ ImpuestoDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="select"
              label="Tipo Factor"
              name="TipoFactorDR"
              placeholder=""
              help=""
              rules={ rules.TipoFactorDR }
              value={ data.TipoFactorDR }
              options={ TipoFactorDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Tasa O Cuota"
              name="TasaOCuotaDR"
              placeholder=""
              help=""
              rules={ rules.TasaOCuotaDR }
              value={ data.TasaOCuotaDR }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Importe"
              name="ImporteDR"
              placeholder=""
              help=""
              rules={ rules.ImporteDR }
              value={ data.ImporteDR }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar impuesto
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

const ImpuestoDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'ISR',
    value: '001'
  },
  {
    label:'IVA',
    value: '002'
  },

  {
    label:'IEPS',
    value: '003'
  }
];

const TipoFactorDR = [
  {
    label:'Selecciona',
    value: ''
  },
  {
    label:'Tasa',
    value: 'Tasa'
  },
  {
    label:'Cuota',
    value: 'Cuota'
  },
];

export default DocumentoImpuestosRetencionForm;